"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReactHTMLPicture = (0, _component.default)(function () {
  return import("@micado-digital/react-htmlpicture/ReactHTMLPicture");
});
var useStyles = (0, _makeStyles.default)(function (theme) {
  var _root, _image;

  return {
    root: (_root = {}, _defineProperty(_root, theme.breakpoints.up("md"), {
      display: "grid",
      gridColumnGap: theme.spacing(4),
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "auto"
    }), _defineProperty(_root, theme.breakpoints.up("lg"), {
      gridColumnGap: theme.spacing(6)
    }), _root),
    rootLeft: {
      "& .mco-imagetext-01__image": _defineProperty({}, theme.breakpoints.up("md"), {
        gridColumn: "2 / 3"
      }),
      "& .mco-imagetext-01__content": _defineProperty({}, theme.breakpoints.up("md"), {
        gridColumn: "1 / 2"
      })
    },
    image: (_image = {
      marginBottom: theme.spacing(2)
    }, _defineProperty(_image, theme.breakpoints.up("md"), {
      gridColumn: "1 / 2",
      gridRow: "1 / -1",
      marginBottom: 0
    }), _defineProperty(_image, "& img", {
      height: "100%",
      width: "100%"
    }), _image),
    content: _defineProperty({}, theme.breakpoints.up("md"), {
      display: "flex",
      flexDirection: "column",
      gridColumn: "2 / 3",
      gridRow: "1 / -1"
    })
  };
});

var ReactImageText01 = function ReactImageText01(_ref) {
  var headline = _ref.addition2,
      alt = _ref.alt,
      _ref$headlineVariant = _ref.headlineVariant,
      headlineVariant = _ref$headlineVariant === void 0 ? "h3" : _ref$headlineVariant,
      media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      mediaPath = _ref.mediaPath,
      _ref$option = _ref.option,
      alignment = _ref$option === void 0 ? 0 : _ref$option,
      text = _ref.text,
      subTitle = _ref.title;
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.root, "mco-imagetext-01", "mco-imagetext-01__wrapper--".concat(alignment === 0 ? "right" : "left"), _defineProperty({}, css.rootLeft, alignment === 1))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("mco-imagetext-01__image", css.image),
    style: {
      order: alignment
    }
  }, /*#__PURE__*/_react.default.createElement(ReactHTMLPicture, _extends({
    alt: alt,
    media: media,
    path: mediaPath,
    webpFallback: true
  }, mediaFormats))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.content, "mco-imagetext-01__content")
  }, subTitle && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-imagetext-01__subtitle",
    component: "p",
    variant: "subtitle2"
  }, subTitle), headline && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-imagetext-01__title",
    color: "secondary",
    dangerouslySetInnerHTML: {
      __html: headline
    },
    gutterBottom: true,
    variant: headlineVariant
  }), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-imagetext-01__text",
    component: "div",
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};

ReactImageText01.propTypes = {
  addition2: _propTypes.default.string,
  alt: _propTypes.default.string,
  headlineVariant: _propTypes.default.string,
  media: _propTypes.default.object.isRequired,
  mediaFormats: _propTypes.default.object,
  mediaPath: _propTypes.default.string,
  option: _propTypes.default.number,
  text: _propTypes.default.string,
  title: _propTypes.default.string
};
var _default = ReactImageText01;
exports.default = _default;